import SHARED_STYLES from 'json/shared_styles.json';

function isDeviceWidth(deviceMaxWidth) {
  return getWindowWidth() <= deviceMaxWidth;
}

export function getWindowWidth() {
  return $('body').innerWidth();
}
export function getWindowHeight() {
  return $('body').innerHeight();
}
export function getWindowScrollTop() {
  return $(window).scrollTop();
}

function getDeviceMaxWidth(sizeString) {
  return parseInt(SHARED_STYLES.breakpoints[sizeString], 10) - 1;
}

function getDeviceMinWidth(sizeString) {
  return parseInt(SHARED_STYLES.breakpoints[sizeString], 10);
}

export var isMobileWidth = isDeviceWidth.bind(null, getDeviceMaxWidth('small'));
export var isPhabletWidth = isDeviceWidth.bind(null, getDeviceMaxWidth('medium'));
export var isDesktopWidth = isDeviceWidth.bind(null, getDeviceMinWidth('large'));